import { render, staticRenderFns } from "./RecordingsLinkForm.vue?vue&type=template&id=34d12b06&"
import script from "./RecordingsLinkForm.vue?vue&type=script&lang=js&"
export * from "./RecordingsLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports